import store from "../store";
import { removeUndefinedProps } from "../utils/removeUndefinedProps";
import { getCookie } from "src/utils";

const getParams = (componentName, componentIdx, extraParams = {}) => {
  const { clientid: clientId, variant, brand: originalBrand, page, ...config } = store("config");
  const brand = originalBrand == "undefined" ? undefined : originalBrand;

  const params = Array.isArray(extraParams)
    ? extraParams.reduce((acc, curr) => {
        acc[curr] = config[curr];
        return acc;
      }, {})
    : extraParams;

  return new URLSearchParams(removeUndefinedProps({ componentName, componentIdx, clientId, variant, brand, page, ...params }));
};

const appendFacebookCookies = (params) => {
  const fbClickId = getCookie('_fbc');
  const fbBrowserId = getCookie('_fbp');

  if (fbClickId) {
    params.append('fbClickId', fbClickId);
  }
  if (fbBrowserId) {
    params.append('fbBrowserId', fbBrowserId);
  }
};

export const fireImpressionEvent = (componentName, componentIdx, extraParams = {}) => {
  const params = getParams(componentName, componentIdx, extraParams);
  appendFacebookCookies(params);

  const domain = window.GLOBALS.API.EVENT_TRACKER_URI;
  fetch(`${domain}/pagebuilder-event/impression?${params.toString()}`);
};

export const fireClickEvent = (componentName, componentIdx, extraParams = {}, useBeacon) => {
  const params = getParams(componentName, componentIdx, extraParams);
  appendFacebookCookies(params);
  appendPostbackCustomData(params);
  const domain = window.GLOBALS.API.EVENT_TRACKER_URI;
  if (navigator.sendBeacon && useBeacon) {
    const beaconData = {};
    params.forEach((value, key) => {
      beaconData[key] = value;
    });
    const blob = new Blob([JSON.stringify(beaconData)], { type: "application/json" });
    navigator.sendBeacon(`${domain}/pagebuilder-event/click`, blob);
  } else {
    fetch(`${domain}/pagebuilder-event/click?${params.toString()}`, { keepalive: true });
  }
};


const appendPostbackCustomData = (params) => {
  const urlParams = new URLSearchParams(window.location.href);
  urlParams.forEach((value, key) => {
    if (key.startsWith('cx_')) {
      params.append(key, value);
    }
  });
}